module.exports = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/21319dde4603fb62261222442ef4d02b.svg";